import React from 'react';
import styles from './ProjectCardHeader.module.scss';
import { SFText } from 'sfui';
import { TagsInformation } from './TagsInformation/TagsInformation';
import { ProjectTags } from '../../../../../../../Models/ProjectValue';
import { ProjectCardActions } from './ProjectCardActions/ProjectCardActions';

export interface ProjectCardHeaderProps {
  className?: string;
  name: string;
  tags: ProjectTags;
  isButtonDisabled: boolean;
  onSeeRecentReports: () => void;
}

export const ProjectCardHeader = ({
  className = '',
  name,
  tags,
  isButtonDisabled,
  onSeeRecentReports
}: ProjectCardHeaderProps): React.ReactElement<ProjectCardHeaderProps> => {
  return (
    <div className={`${styles.projectCardHeader} ${className}`}>
      <div className={styles.information}>
        <div className={styles.incidentNumber}>
          <SFText type="component-messages" sfColor="neutral">
            PROJECT
          </SFText>
          <SFText type="component-title">{name}</SFText>
        </div>

        <ProjectCardActions
          isButtonDisabled={isButtonDisabled}
          onSeeRecentReports={onSeeRecentReports}
        />
      </div>
      <div className={styles.valueAndChips}>
        <SFText type="component-messages" sfColor="neutral">
          TAGS
        </SFText>
        <div className={styles.chips}>
          <TagsInformation tags={tags} />
        </div>
      </div>
    </div>
  );
};
